

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface IpReportParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface IpReport {

  fromDate: any;
  toDate: any;
  Id: any;
   
    tenantId?: string;
    branchId?: string;
    
  
    parameters?: IpReportParameter[];
    links?: any;
}

export abstract class IpReportData {


  abstract searchList(url: string, data:any): Observable<any>;
}
